import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {LoggingService} from "mclane-apptemplate-lib";
import { LoginProperties } from 'mclane-webauth-lib';
@Injectable({
    providedIn: 'root'
})
export class KeycloakHelperService {

    constructor(public keycloakService: KeycloakService,
                public console: LoggingService) {

    }


    public Login(options: LoginProperties) {
        if (options == null) {
            return this.keycloakService.getKeycloakInstance()
                .login({redirectUri: options.callbackUrl}).then((result) => {
                    this.console.log(result);
                });
        } else {
            return this.keycloakService.getKeycloakInstance()
                .login({idpHint: options.idpHint, redirectUri: options.callbackUrl}).then((result) => {
                    this.console.log(result);
                });
        }


    }
}
